import React from 'react';
import PropTypes from 'prop-types';
import Stop from 'components/form/Stop';
import orderConstants from 'utils/order/constants';
import dateAndTimeConstants from 'utils/dateAndTimes/constants';
import { AddButton } from 'refactored/ui/form';

const config = {
  [orderConstants.DISTRIBUTION]: {
    mainStopType: dateAndTimeConstants.STOP_TYPES.pickup,
    diffStopType: dateAndTimeConstants.STOP_TYPES.dropoff,
  },
  [orderConstants.COLLECTION]: {
    mainStopType: dateAndTimeConstants.STOP_TYPES.dropoff,
    diffStopType: dateAndTimeConstants.STOP_TYPES.pickup,
  },
};

const MRStops = ({
  className,
  t,
  shipmentKeys,
  typeOfOrder,
  handleAddShipment,
  loadsInForm,
  maxReached,
  isEditing,
}) => {
  const mainStopType = config[typeOfOrder].mainStopType;
  const diffStopType = config[typeOfOrder].diffStopType;

  return (
    <div className={className}>
      {typeOfOrder === orderConstants.DISTRIBUTION && (
        <Stop
          shipmentKey={shipmentKeys[0]}
          stopType={mainStopType}
          loadsInForm={loadsInForm}
          typeOfOrder={typeOfOrder}
        />
      )}

      {shipmentKeys.map((shipmentKey, index) => (
        <Stop
          key={index}
          shipmentKey={shipmentKey}
          stopType={diffStopType}
          position={index + 1}
          canDelete={shipmentKeys.length >= 3}
          isMultiRoute
          typeOfOrder={typeOfOrder}
        />
      ))}

      {!isEditing && (
        <>
          <div className="addShipment-disabled">
            {!maxReached ? (
              <AddButton
                handleAdd={handleAddShipment}
                label={t(`add_${config[typeOfOrder].diffStopType}_stop`)}
              />
            ) : (
              t('max_stops_reached')
            )}
          </div>
        </>
      )}

      {typeOfOrder === orderConstants.COLLECTION && (
        <Stop
          className="collectionMainStop"
          shipmentKey={shipmentKeys[0]}
          stopType={config[typeOfOrder].mainStopType}
          loadsInForm={loadsInForm}
          typeOfOrder={typeOfOrder}
        />
      )}
    </div>
  );
};

MRStops.propTypes = {
  className: PropTypes.string,
  typeOfOrder: PropTypes.string,
  shipmentKeys: PropTypes.arrayOf(PropTypes.string),
  handleAddShipment: PropTypes.func,
  loadsInForm: PropTypes.arrayOf(PropTypes.shape({})),
  t: PropTypes.func,
  maxReached: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool,
};

MRStops.defaultProps = {
  className: '',
  typeOfOrder: '',
  shipmentKeys: [],
  handleAddShipment: () => ({}),
  t: (t) => t,
  loadsInForm: [],
  isEditing: false,
};

export default MRStops;
